import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[decimalNumber]',
    standalone: false
})
export class DecimalNumberDirective {
    constructor(private el: ElementRef) {
    }

    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    @Input() decimalPrecision: number = 2;

    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];


    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        const regex = new RegExp(`^\\d*\\.?\\d{0,${this.decimalPrecision}}$`);

        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
        if (next && !String(next).match(regex)) {
            event.preventDefault();
        }
    }
}
